import { render } from "./MediaLibraryInModal.vue?vue&type=template&id=e5f4058a&scoped=true"
import script from "./MediaLibraryInModal.vue?vue&type=script&lang=js"
export * from "./MediaLibraryInModal.vue?vue&type=script&lang=js"

import "./MediaLibraryInModal.vue?vue&type=style&index=0&id=e5f4058a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f4058a"]])

export default __exports__